import { render, staticRenderFns } from "./referrer-share.vue?vue&type=template&id=74d0fdd1&scoped=true"
import script from "./referrer-share.vue?vue&type=script&lang=js"
export * from "./referrer-share.vue?vue&type=script&lang=js"
import style0 from "./referrer-share.vue?vue&type=style&index=0&id=74d0fdd1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d0fdd1",
  null
  
)

export default component.exports